import { render, staticRenderFns } from "./defect_summary.vue?vue&type=template&id=2b2d80f4&scoped=true"
import script from "./defect_summary.vue?vue&type=script&lang=js"
export * from "./defect_summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d80f4",
  null
  
)

export default component.exports